import CandidateRoutes from 'candidate/routes'
import ClientRoutes from 'client/routes'
import RecruiterRoutes from 'recruiter/routes'
import { UserRole } from 'shared/models/types/User'

export const getProtectedRoutes = (subdomain) => {
    switch (subdomain) {
        case UserRole.recruiter:
            return RecruiterRoutes
        case UserRole.client:
            return ClientRoutes
        case UserRole.candidate:
            return CandidateRoutes
        default:
            return []
    }
}

export const getSubdomain = (domain = 'localhost') => {
    const locationParts = window.location.hostname.split('.')
    const domainIndex = locationParts.findIndex(
        (part) => part === domain.split('.')[0]
    )
    let existingSubdomain = ''
    // handle no subdomain (should only happen in localhost)
    if (domainIndex !== 0) existingSubdomain = locationParts[domainIndex - 1]
    // remove env specifiers like dev- or staging-
    if (existingSubdomain?.split('-')[1])
        existingSubdomain = existingSubdomain.split('-')[1]
    return existingSubdomain
}
